import { render, staticRenderFns } from "./ContactUsList.vue?vue&type=template&id=044907a9"
import script from "./ContactUsList.vue?vue&type=script&lang=js"
export * from "./ContactUsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports